<section role="dialog" aria-modal="true" aria-labelledby="contact-title" class="sm:h-[55rem] max-w-[80vw] sm:w-[51.2rem] flex flex-col items-center justify-center">
    <div class="sm:h-[43rem] max-sm:min-w-[65vw] sm:w-[39.4rem] flex flex-col items-center justify-center sm:gap-[4rem] gap-[6rem]">
        <button type="button" class="absolute top-[4rem] right-[4rem] cursor-pointer" (click)="closePopup()" aria-label="Close contact form">
            <dsr-icon name="cancel" size="1.6rem" color="black" aria-hidden="true"></dsr-icon>
        </button>
        <div class="flex flex-col items-center justify-center">
            <h2 mat-dialog-title id="contact-title" class="!min-h-fit">
                {{'FOOTER_INFORMATION_TITLE2' | translate}}   
            </h2>
            <span class="dsr-typescale-body-small-prominent">*{{'FORM_MANDATORY_TEXT' | translate}}</span>
        </div>

        <form [formGroup]="contactForm" (ngSubmit)="submitForm()" class="w-full">
            <fieldset class="w-full min-w-full flex flex-col sm:gap-[2rem] gap-[7rem] h-full items-center">
                <legend class="sr-only">Contact form</legend>
                
                    <div mat-dialog-content class="w-full">
                        <div class="!w-full  flex flex-col pt-4 !gap-[4rem]">
                           
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>{{'CONTACT_EMAIL_LABEL' | translate}}</mat-label>
                                <input matInput id="{{'CONTACT_EMAIL_LABEL' | translate}}" type="email" required
                                       placeholder="{{'FORM_EMAIL_PLACEHOLDER' | translate}}"
                                       formControlName="email" [(ngModel)]="email" aria-required="true"
                                       autocomplete="email" />
                                <dsr-icon name="mail" matSuffix aria-hidden="true"></dsr-icon>
                                @if(contactForm.get('email')?.invalid && contactForm.get('email')?.touched) {
                                <mat-error>{{getErrorMessage('email')}}</mat-error>
                                }
                            </mat-form-field>
                            
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>{{'CONTACT_MESSAGE_LABEL' | translate}}</mat-label>
                                <textarea matInput id="{{'CONTACT_MESSAGE_LABEL' | translate}}"
                                required
                                          placeholder="{{'CONTACT_MESSAGE_PLACEHOLDER' | translate}}"
                                          class="min-h-[8rem] h-full w-full" formControlName="message"
                                          maxlength="1000" aria-required="true"></textarea>
                                @if(contactForm.get('message')?.invalid && contactForm.get('message')?.touched) {
                                <mat-error>{{getErrorMessage('message')}}</mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>
                
                <div mat-dialog-actions role="group" aria-label="Contact form actions" class="">
                    <button mat-flat-button class="" type="submit" [attr.aria-busy]="contactForm.pending">
                        <span class="capitalize">{{'SEND_TEXT' | translate}}</span>
                    </button>
                    <button mat-stroked-button color="primary" type="button" (click)="closePopup()" aria-label="Cancel contact form">
                        <span class="capitalize">{{'CANCEL_BUTTON' | translate}}</span>
                    </button>
                </div>
            </fieldset>
        </form>
    </div>
</section>